import type { RouteObject } from "react-router-dom";

export const settingsAgentRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Settings Agent" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => false} /> };
    },
    children: [
      {
        path: ":teamId",
        async lazy() {
          const { SettingsAgentPage } = await import("./settings-agent-page");
          return { Component: SettingsAgentPage };
        },
      },
    ],
  },
];
